import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=1b143334&scoped=true"
import script from "./ExpensesList.vue?vue&type=script&lang=js"
export * from "./ExpensesList.vue?vue&type=script&lang=js"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&id=1b143334&prod&lang=scss&scoped=true"
import style1 from "./ExpensesList.vue?vue&type=style&index=1&id=1b143334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b143334",
  null
  
)

export default component.exports